import React, { Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { Helmet } from 'react-helmet';
import reportWebVitals from './reportWebVitals';
import LandingPage from './components/templates/landing-page';
import LandingPageMobile from './components/templates/landing-page-mobile';
import Login from './components/organisms/login';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PerfilSatProvider } from './context/perfil.sat.context';
import Home from './components/organisms/home';
import UploadFiles from './components/organisms/upload-files';

const App: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowWidth > 440 ? <LandingPage /> : <LandingPageMobile />;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={'/'}>
      <Helmet>
        <meta name='robots' content='noindex, nofollow' />
      </Helmet>
      <PerfilSatProvider>
        <Suspense>
          <Routes>
            <Route path={'/'} element={<App />} />
            <Route path={'/login'} element={<Login />} />
            <Route path={'/home'} element={<Home />} />
            <Route path={'/upload-files'} element={<UploadFiles/>} />
          </Routes>
        </Suspense>
      </PerfilSatProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
